import React from 'react';
import __ from 'lodash';

class DdKategori extends React.Component{
    render(){
        return (
            this.props.kategori.map((val) =>
                <option key={val.id_kategori_bank_soal} value={val.id_kategori_bank_soal}>{val.nama_kategori}</option>
            )            
        )
    }
}

export default DdKategori;